import { render, staticRenderFns } from "./CancellationPolicyText.vue?vue&type=template&id=79f5cf09&scoped=true&"
import script from "./CancellationPolicyText.vue?vue&type=script&lang=js&"
export * from "./CancellationPolicyText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79f5cf09",
  null
  
)

export default component.exports